@if (isLoaded) {
	@if (products?.length) {
		<div class="product-slider">
			@if (isLoaded && selectedData) {
				<div class="product-slider__info-block">
					<p class="product-slider__product-name">
						{{ selectedData.label }}
						{{ selectedData.name }}
					</p>
					@if (selectedData.isArrested) {
						<div class="product-slider__status-wrapper">
							<span
								class="product-slider__status color-status color-status--in-progress"
							>
								Ограничения
							</span>
						</div>
					}
					@if (!isCredit && !isBonus) {
						<div
							class="product-slider__product-amount product-slider__base-product-tamplate"
						>
							@if (!selectedData.multiProductId) {
								<span class="product-balance">
									<app-product-balance
										class="product-list-item__balance-wrapper"
										[productId]="selectedData.productId"
									></app-product-balance>
								</span>
							} @else {
								@if (selectedData.multiProductId) {
									@for (
										multiProductId of selectedData.multiProductId;
										track multiProductId
									) {
										<app-product-balance
											class="product-list-item__balance-wrapper"
											[productId]="multiProductId"
										></app-product-balance>
									}
								}
							}
							@if (selectedData.cardType) {
								<p class="product-slider__product-type-and-number-block">
									@if (selectedData.cardType) {
										<span class="product-slider__product-type">
											{{ selectedData.cardType }}
										</span>
									}
									@if (!isCredit && selectedData.productNumber) {
										<span class="product-slider__product-number">
											{{ selectedData.productNumber }}
										</span>
									}
								</p>
							} @else {
								@if (!isCredit && selectedData.productNumber) {
									<p class="product-slider__product-number-block">
										<span
											class="product-slider__product-number product-slider__product-number--without-card-type"
										>
											{{ selectedData.productNumber }}
										</span>
									</p>
								}
							}
						</div>
					} @else {
						@if (isCredit) {
							@if (selectedData.debts | async; as debts) {
								<div
									class="product-slider__product-amount product-slider__credit-tamplate"
								>
									<strong class="product-slider__credit-amount">
										{{ debts.debtSum | amountincurrency }}
									</strong>
									<div class="product-slider__credit-debt">
										<div class="product-slider__credit-payment">
											<span>Сумма платежа</span>
											<span class="product-slider__credit-payment-day">
												@if (debts?.creditPaymentDayAmount?.paymentDay) {
													до&nbsp;{{
														debts?.creditPaymentDayAmount?.paymentDay
															| date: 'dd.MM.yyyy'
													}}
												}
											</span>
										</div>
										<strong class="product-slider__credit-payment-amount">
											{{
												debts?.creditPaymentDayAmount?.repaymentAmount
													| amountincurrency
											}}
										</strong>
									</div>
									@if (debts?.creditPartRepaymentAmount) {
										<div class="product-slider__credit-debt">
											<div class="product-slider__credit-payment">
												<span>Погасить частично</span>
												<span class="product-slider__credit-payment-day">
													@if (
														debts?.creditPartRepaymentAmount?.paymentDay
													) {
														до&nbsp;{{
															debts?.creditPartRepaymentAmount
																?.paymentDay | date: 'dd.MM.yyyy'
														}}
													}
												</span>
											</div>
											@if (
												debts?.creditPartRepaymentAmount?.repaymentAmount
													?.amount === 0
											) {
												<span
													class="product-slider__status color-status color-status--done"
												>
													Оплачено
												</span>
											} @else {
												<strong
													class="product-slider__credit-payment-amount"
												>
													{{
														debts?.creditPartRepaymentAmount
															?.repaymentAmount | amountincurrency
													}}
												</strong>
											}
										</div>
									}
									@if (debts?.creditFullRepaymentAmount) {
										<div class="product-slider__credit-debt">
											<div class="product-slider__credit-payment">
												<span>Погасить кредит полностью</span>
												<span class="product-slider__credit-payment-day">
													@if (
														debts?.creditFullRepaymentAmount?.paymentDay
													) {
														до&nbsp;{{
															debts?.creditFullRepaymentAmount
																?.paymentDay | date: 'dd.MM.yyyy'
														}}
													}
												</span>
											</div>
											<strong class="product-slider__credit-payment-amount">
												{{
													debts?.creditFullRepaymentAmount
														?.repaymentAmount | amountincurrency
												}}
											</strong>
										</div>
									}
								</div>
							}
						}
						@if (isBonus) {
							<div
								class="product-slider__product-amount product-slider__bonus-tamplate"
							>
								@if (selectedData.balance?.value) {
									<span class="product-balance">
										{{ selectedData.balance?.value | amountincurrency }}
									</span>
								}
								@if (!selectedData.balance?.active) {
									<a
										class="link product-list-item__details-active-link"
										[routerLink]="['/bonus/activate/', selectedData.programId]"
									>
										Подключить
									</a>
								}
							</div>
						}
						@if (selectedData.cardType) {
							<p class="product-slider__product-type-and-number-block">
								@if (selectedData.cardType) {
									<span class="product-slider__product-type">
										{{ selectedData.cardType }}
									</span>
								}
								@if (!isCredit && selectedData.productNumber) {
									<span class="product-slider__product-number">
										{{ selectedData.productNumber }}
									</span>
								}
							</p>
						} @else {
							@if (!isCredit && selectedData.productNumber) {
								<p class="product-slider__product-number-block">
									<span
										class="product-slider__product-number product-slider__product-number--without-card-type"
									>
										{{ selectedData.productNumber }}
									</span>
								</p>
							}
						}
					}
				</div>
			}
			<div
				class="product-slider__slider-container-wrapper"
				[ngClass]="{
					'product-slider__slider-container-wrapper--one-slide':
						products && products.length === 1,
				}"
			>
				<div class="product-slider__slider-container">
					@if (tinySliderConfig) {
						<app-tiny-slider [sliderConfig]="tinySliderConfig">
							@for (item of products; track item; let i = $index) {
								<div
									class="product-slider__slider-item"
									draggable="false"
									[ngClass]="{
										'product-slider__slider-item--selected':
											i === selectedDataIndex,
									}"
									[attr.data-index]="i"
									#imageWrapper
								>
									@if (item.productId) {
										<div
											class="card-statuses product-slider__slider-item-image-wrapper"
											(click)="sliderItemClick(item)"
										>
											@if (item.productId.productType === 'CARD') {
												<div class="card-statuses__list">
													@if (item.favourite) {
														<app-card-label-status
															class="card-statuses__item"
															[status]="'FAVORITE'"
														></app-card-label-status>
													}
													@if (item.isAdditionalCard) {
														<app-card-label-status
															class="card-statuses__item"
															[status]="'ADDITIONAL'"
														></app-card-label-status>
													}
													@for (
														itemStatus of item.cardStatusList;
														track itemStatus
													) {
														<app-card-label-status
															class="card-statuses__item"
															[status]="itemStatus"
														></app-card-label-status>
													}
												</div>
											}
											<app-product-image
												[image]="item.image || item.productDesign.image"
												[productImageParams]="{
													size: CARD_PICTURE.TABLET,
													paymentSystem: item.paymentSystem,
													disabled: item.isArrested,
												}"
											></app-product-image>
										</div>
									}
								</div>
							}
						</app-tiny-slider>
					}
				</div>
			</div>
			@if (isHasNavigation()) {
				<div class="product-slider__counter">
					<span class="product-slider__current-slide-number">
						{{ selectedDataIndex + 1 }}
					</span>
					<span class="product-slider__slides-slash">/</span>
					<span class="product-slider__total-slides-number">{{ products?.length }}</span>
				</div>
			}
		</div>
	}
} @else {
	<article class="product-slider__skeletone">
		<div class="product-slider__text-content">
			<span class="product-slider__skeleton-line"></span>
			<span
				class="product-slider__skeleton-line product-slider__skeleton-line--title-last-row"
			></span>
			<span class="product-slider__skeleton-line"></span>
			<div class="product-slider__skeletone-row">
				<span
					class="product-slider__skeleton-line product-slider__skeleton-line--card-type"
				></span>
				<span
					class="product-slider__skeleton-line product-slider__skeleton-line--card-number"
				></span>
			</div>
		</div>
		<div class="product-slider__image-block"></div>
	</article>
}

<!-- //TEMPLATES -->
<!-- BASE -->

<!-- OTHERS PRODUCTS -->

<!-- BONUS -->

<!-- CREDIT -->

<!-- TYPE AND NUMBER Info -->

<!-- ONLY NUMBER Info -->
